import React from 'react'
import { connect } from 'react-redux'
import { openAllotmentResultEnquiry, openApplyDialog, openMarginApplyDialog } from '@/actions/app';
import { getSafe } from '../../../helpers/global';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
import { COMPANY_SUPPORTS } from '@/constants/companys';

class OrderCellRender extends React.Component {
  render() {
    return this.renderContent()
  }

  renderOrderType() {
    const { data, language } = this.props;
    const key = `order_type_${data.orderType.toLowerCase()}`
    return (
      <div>
        <span>{language[key] ? language[key] : data.orderType.toUpperCase()}</span>
      </div>
    )
  }

  renderOrderDirection() {
    const { data, language } = this.props;
    const key = data.bs === 'B' ? 'common_buy' : 'common_sell';
    // const bgClass = data.bs === 'B' ? 'rise-color' : 'fall-color';
    const bgColor = data.bs === 'B' ? 'order-direction-b' : 'order-direction-s';
    return (
      // <div className={bgClass}>
      <div className={bgColor}>
        <span>{language[key]}</span>
      </div>
    )
  }

  bindingStatus(value) {
    switch (value) {
      case 'REJ': return 'status status-refused';
      case 'KLL': return 'status status-inactive';
      case 'CAN': return 'status status-inactive';
      case 'SPC': return 'status status-inactive';
      case 'EXP': return 'status status-inactive';
      case 'PEX': return 'status status-inactive';
      case 'BIX2': return 'status status-inactive';
      case 'PSB': return 'status status-ongoing';
      case 'SND': return 'status status-ongoing';
      case 'BMS': return 'status status-ongoing';
      case 'BSS': return 'status status-ongoing';
      case 'CMO': return 'status status-ongoing';
      case 'MSD': return 'status status-ongoing';
      case 'MXX': return 'status status-ongoing';
      case 'STB': return 'status status-ongoing';
      case 'SPO': return 'status status-ongoing';
      case 'BIX': return 'status status-ongoing';
      case 'CPD': return 'status status-filled';
      case 'FLL': return 'status status-filled';
      case 'FEX': return 'status status-filled';
      case 'ALF': return 'status status-filled';
      case 'SPF': return 'status status-filled';
      case 'PXP': return 'status status-filled';
      case 'SPP': return 'status status-filled';
      case 'IAV': return 'status status-ongoing';
      case 'SOI': return 'status status-ongoing';
      case 'NEW': return 'status status-ongoing';
      case 'SOR': return 'status status-ongoing';
      default: return '';
    }
  }

  renderStatus() {
    const { data, language, orderTabName } = this.props;
    let key 
    if(iTradeEnv.company===COMPANY_SUPPORTS.SCB){
       key = `order_status_query_${data.status.toLowerCase()}`
    }else{
      key = `order_status_${data.status.toLowerCase()}`
    }
    const bgClass = this.bindingStatus(data.status.toUpperCase());
    return (
      <div className={bgClass}>
        <span>{language[key] ? language[key] : data.statusDesc}</span>
      </div>
    )
  }

  renderContent() {
    const { colDef } = this.props;
    switch (colDef.colId) {
      case 'common_buy_sell': return this.renderOrderDirection();
      case 'funds_buy_sell': return this.renderOrderDirection();
      case 'common_order_type': return this.renderOrderType();
      case 'funds_order_type': return this.renderOrderType();
      case 'common_status': return this.renderStatus();
      case 'funds_status': return this.renderStatus();
      case 'common_order_history_status': return this.renderStatus();
      default: break;
    }
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(OrderCellRender)
